/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbLayoutModule,
  NbMenuModule,
  NbSidebarModule,
  NbSpinnerModule,
  NbTagModule,
  NbTimepickerModule,
  NbToastrModule,
  NbTooltipModule,
  NbWindowModule,
} from '@nebular/theme';
import { environment } from '../environments/environment';
import { getApp, provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { initializeAppCheck, provideAppCheck, ReCaptchaEnterpriseProvider } from '@angular/fire/app-check';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { NbAuthModule } from '@nebular/auth';
import { CustomLoginComponent } from './auth/custom-login/custom-login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NbInputModule, NbButtonModule, NbCardModule, NbAlertModule, NbCheckboxModule, NbIconModule, NbSelectModule } from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { provideMessaging, getMessaging } from '@angular/fire/messaging';
import { FilterPermissionPipe } from './pipes/filter-permission.pipe';
import { UploadProfilePopupOpenerComponent } from './auth/upload-profile-popup-opener/upload-profile-popup-opener.component';
import { UploadProfilePopupComponent } from './auth/upload-profile-popup/upload-profile-popup.component';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { CustomRegisterComponent } from './auth/custom-register/custom-register.component';
import { CustomForgotPasswordComponent } from './auth/custom-forgot-password/custom-forgot-password.component';
import { CountUpDirective } from './constants/count-up.directive';
import { PortusRouteReuseStrategy } from './pages/route-reuse.strategy';
import { RouteReuseStrategy } from '@angular/router';
import { BlTemplateComponent } from './bl-template/bl-template.component';


@NgModule({
  declarations: [AppComponent, UploadProfilePopupOpenerComponent, UploadProfilePopupComponent,CountUpDirective, BlTemplateComponent,],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
  NbCardModule,
NbLayoutModule,
NbButtonModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
       NbDatepickerModule.forRoot(),  // 🔥 REQUIRED
             // 🔥 REQUIRED
    NbDialogModule.forRoot(),
    // NbDialogModule.forChild(), // ✅ THIS IS REQUIRED
    NbEvaIconsModule,
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: (environment as any).googleMapsApiKey || '',
    }),
    NbTagModule,
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    NbSpinnerModule,
    NbTooltipModule,
    NbTimepickerModule.forRoot(),
    provideFirebaseApp(() => initializeApp(environment.firebase)),


    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideMessaging(() => getMessaging()),
    provideStorage(() => getStorage()),


  ],
  providers: [
      {
    provide: RouteReuseStrategy,
    useClass: PortusRouteReuseStrategy,
  },
],
  bootstrap: [AppComponent],
})
export class AppModule {
}
